import React from "react";
import NewHeader from "../../directives/NewHeader";
import "../../Styles/NewAboutus.css";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../directives/footer";
import DownloadSection from "./DownloadSection";
import AboutUsMetaTag from "../MetaTags/AboutUsMetaTag";

const NewAboutUs = () => {
  return (
    <>
      <div className="position-fixed w-100 " style={{ zIndex: 999 }}>
        <NewHeader />
        <AboutUsMetaTag />

      </div>
      <div className="about-us-top-shelf-start"></div>
      <div className="position-relative">
        <div className="cp1"></div>
        <div className="cp2"></div>
        <div className="cp3"></div>
        <div className="cp4"></div>
        <div className="cp5"></div>
        <div className="cp6"></div>
        <div className="cp8"></div>
        <Container className="h-100">
          <div className="new-aboutus-01  ">
            <h3 className="new-aboutus-01-backheader">OUR MISSION</h3>
            <p className="new-aboutus-01-header">OUR MISSION</p>
          </div>
        </Container>

        {/* SECTION01  */}
        <div className="position-relative">
          <div className="new-aboutus-s01"></div>
          <Container className="">
            <Row>
              <Col lg={6}>
                <div>
                  <img src="assets\images\newdesign\apos1.svg" alt="" />
                  <p className="px-4" style={{ fontSize: 18 }}>
                    To transform everyday movement into meaningful wealth. We
                    empower people to take charge of their health — and get
                    rewarded for it. Through the power of Web3, Stepmint makes
                    every step count, turning your daily hustle into real crypto
                    gains
                  </p>
                  <div className="w-100 d-flex justify-content-end">
                    <img
                      src="assets\images\newdesign\apos2.svg"
                      className="text-end"
                      alt=""
                    />
                  </div>
                </div>
              </Col>
              <Col lg={6} className="position-relative">
                <div className="w-100 text-end h-100 ">
                  <img
                    src="assets\images\newdesign\abotus01.png"
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* SECTION02  */}

        <Container className="h-100">
          <div className="new-aboutus-01  ">
            <h3 className="new-aboutus-01-backheader">OUR VISION</h3>
            <p className="new-aboutus-01-header">OUR VISION</p>
          </div>
        </Container>

        <div className="position-relative">
          <div className="new-aboutus-s02"></div>
          <Container className="">
            <Row className="about-us-section02">
              <Col lg={6} className="">
                <div
                  className="w-100 text-start  h-100 d-flex align-items-end "
                  style={{ bottom: 0 }}
                >
                  <img
                    src="assets\images\newdesign\aboutus02.png"
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <img src="assets\images\newdesign\apos1.svg" alt="" />
                  <p className="px-4" style={{ fontSize: 18 }}>
                    A world where walking fuels your wallet and your well-being.
                    We imagine a future where fitness isn’t a chore — it’s a
                    lifestyle powered by technology, community, and real-world
                    rewards. Our goal? To make physical activity profitable,
                    accessible, and addictive (in the best way).
                  </p>
                  <div className="w-100 d-flex justify-content-end">
                    <img
                      src="assets\images\newdesign\apos2.svg"
                      className="text-end"
                      alt=""
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* SECTION STARTS HERE */}

        <Container className="h-100">
          <div className="new-aboutus-01 ">
            <h3 className="new-aboutus-01-backheader">BEHIND STEPMINT</h3>
            <p className="new-aboutus-01-headerbrand">
              The Power <br /> Behind StepMint
            </p>
          </div>
          <div>
            <p style={{ fontSize: 32 }}>
              Led by Icons.
              <span className="new-about-us-custom-text">
                {" "}
                Backed by Vision.
              </span>
            </p>
            <p className="brand-para text-secondary">
              Behind every great movement is a team that inspires trust, drives
              change, and leads with purpose. At StepMint, we’re proud to be
              powered by individuals who exemplify excellence in both
              performance and strategy.
            </p>
          </div>
        </Container>
        <br />
        <br />
        <div className="position-relative">
          <div className="brand-back"></div>
          <Container className="position-relative">
            <h3
              className="new-aboutus-01-backheaderbrand"
              style={{ zIndex: -1 }}
            >
              BRAND AMBASSADOR
            </h3>
            <Row>
              <Col lg={6}>
                <div className="h-100">
                  <img
                    className="img-fluid"
                    src="assets\images\newdesign\saina.png"
                    alt=""
                  />
                </div>
              </Col>
              <Col
                lg={6}
                className="d-flex justify-content-center align-items-end"
              >
                <div className="w-100  mb-5">
                  <p className="behind mb-0">Saina Nehwal </p>
                  <div>
                    <p className="behind-small mb-2">— Brand Ambassador</p>
                    <p>
                      A name synonymous with discipline, strength, and global
                      achievement, Saina Nehwal brings her legacy of athletic
                      excellence to StepMint as our proud Brand Ambassador.
                    </p>
                    <p>
                      As a world champion, Olympic medalist, and a pioneer for
                      Indian sports, Saina represents the spirit of StepMint:{" "}
                      <b>Dedication, Resilience, & Forward Motion.</b>
                    </p>
                    <p>
                      Her association with StepMint is more than symbolic — it’s
                      a shared belief that health and movement are at the core
                      of a richer, more rewarding life.
                    </p>
                  </div>

                  <div className="d-flex">
                    <div>
                      <img src="assets\images\newdesign\comma01.svg" alt="" />
                    </div>
                    <div>
                      <p className="sign-text mt-4">
                        StepMint is a game-changer. It motivates people to stay
                        active while building something valuable — and I’m proud
                        to be part of that journey.{" "}
                      </p>
                      <div className="w-100 text-end">
                        <img src="assets\images\newdesign\sign.svg" alt="" />
                      </div>
                    </div>
                    <div className="d-flex align-items-end">
                      <img src="assets\images\newdesign\comma02.svg" alt="" />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <br />
        <br />

        {/* SECTION 7 */}

        <DownloadSection />
      </div>
      {/* SECTION 8 */}

      <Footer />
    </>
  );
};

export default NewAboutUs;
